import React, { FC } from 'react'
import { FixedLayout } from 'components/Layout'
import { ForgetConfirmTemplate } from 'components/Templates'

const ForgetConfirm: FC = () => {
  return (
    <FixedLayout title={'パスワードの変更完了'}>
      <ForgetConfirmTemplate />
    </FixedLayout>
  )
}

export default ForgetConfirm
